// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.footer {
    background-image: url(https://www.zazmic.com/wp-content/themes/zazmic/img/bg.png);
    width: 100%;
    display: flex;
    flex-direction: column;
  padding-top: 20px;
  }
  .footer__container {
    flex-direction: row;
    width: 1250px;
    margin: 0 auto;
    max-width: 100%;
    height: 100%;
    justify-content: space-between;
    display: flex;
    @media screen and (max-width: 600px) {
      flex-wrap: wrap;
      width: 100%;
    }
  }
  .copyright {
    flex-direction: row;
    width: 1250px;
    margin: 0 auto;
    max-width: 100%;
    height: 100%;
    justify-content: space-between;
    display: flex;
    @media screen and (max-width: 600px) {
      flex-direction: column-reverse;
      align-items: center;
    }
  }
  .footer-block {
    display: flex;
    flex-direction: column;
  }
  .footer-title {
    color: #1e1c1a !important;
    font-size: 17px;
    font-weight: bold;
    letter-spacing: 0;
    line-height: 30px;
    margin: 0;
    text-align: left;
    padding-bottom: 20px;
  }
  .footer-list {
    margin: 0;
    padding: 0;
  }
  .footer-item {
    color: #1e1c1a !important;
    font-size: 14px;
    font-weight: bold;
    letter-spacing: 0;
    line-height: 30px;
    margin: 0;
    text-decoration: underline;
    text-align: left;
    margin-bottom: 10px;
  }
  .footer-address {
    color: #1e1c1a !important;
    font-size: 14px;
    font-weight: bold;
    letter-spacing: 0;
    line-height: 30px;
    margin: 0;
    text-align: left;
    margin-bottom: 10px;
  }
  .footer-btn {
    height: 40px;
    width: 145px;
    border: none;
    background-color: #1e1c1a;
    color: #ffffff;
    font-family: Roboto;
    font-size: 14px;
    font-weight: 500;
    letter-spacing: 0;
    line-height: 16px;
    box-sizing: border-box;
    cursor: pointer;
  }
  .footer__social {
    align-items: center;
    flex-direction: row;
    margin-top: 65px;
    display: flex;
  
    height: 100px;
    width: 590px;
    max-width: 100%;
    padding: 20px 0 0 255px;
    @media screen and (max-width: 900px) {
      padding: 20px 0 0 0;
      justify-content: center;
    }
  }
  .content__social-media {
    background-color: #000;
    justify-content: center;
    box-sizing: border-box;
    align-items: center;
    border-radius: 50%;
    margin-right: 9px;
    display: flex;
    padding: 12px;
    height: 36px;
    width: 36px;
  }
  .footer__img {
    bottom: 0;
    left: 0;
    height: 174px;
    width: 590px;
    background-size: contain;
    background-repeat: no-repeat;
    position: relative;
    @media screen and (max-width: 600px) {
        width: 100%;
        
       } 
  }
  .copyright-copyright {
    position: absolute;
    margin-top: -69px;
    font-size: 13px;
    font-weight: normal;
    line-height: 1.2;
    color: #fff;
    @media screen and (max-width: 600px) {
      word-break: break-word;
      margin-left: 114px;
  }
  }
  `, "",{"version":3,"sources":["webpack://./src/components/Footer/Footer.css"],"names":[],"mappings":"AAAA;IACI,iFAAiF;IACjF,WAAW;IACX,aAAa;IACb,sBAAsB;EACxB,iBAAiB;EACjB;EACA;IACE,mBAAmB;IACnB,aAAa;IACb,cAAc;IACd,eAAe;IACf,YAAY;IACZ,8BAA8B;IAC9B,aAAa;IACb;MACE,eAAe;MACf,WAAW;IACb;EACF;EACA;IACE,mBAAmB;IACnB,aAAa;IACb,cAAc;IACd,eAAe;IACf,YAAY;IACZ,8BAA8B;IAC9B,aAAa;IACb;MACE,8BAA8B;MAC9B,mBAAmB;IACrB;EACF;EACA;IACE,aAAa;IACb,sBAAsB;EACxB;EACA;IACE,yBAAyB;IACzB,eAAe;IACf,iBAAiB;IACjB,iBAAiB;IACjB,iBAAiB;IACjB,SAAS;IACT,gBAAgB;IAChB,oBAAoB;EACtB;EACA;IACE,SAAS;IACT,UAAU;EACZ;EACA;IACE,yBAAyB;IACzB,eAAe;IACf,iBAAiB;IACjB,iBAAiB;IACjB,iBAAiB;IACjB,SAAS;IACT,0BAA0B;IAC1B,gBAAgB;IAChB,mBAAmB;EACrB;EACA;IACE,yBAAyB;IACzB,eAAe;IACf,iBAAiB;IACjB,iBAAiB;IACjB,iBAAiB;IACjB,SAAS;IACT,gBAAgB;IAChB,mBAAmB;EACrB;EACA;IACE,YAAY;IACZ,YAAY;IACZ,YAAY;IACZ,yBAAyB;IACzB,cAAc;IACd,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,iBAAiB;IACjB,sBAAsB;IACtB,eAAe;EACjB;EACA;IACE,mBAAmB;IACnB,mBAAmB;IACnB,gBAAgB;IAChB,aAAa;;IAEb,aAAa;IACb,YAAY;IACZ,eAAe;IACf,uBAAuB;IACvB;MACE,mBAAmB;MACnB,uBAAuB;IACzB;EACF;EACA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,sBAAsB;IACtB,mBAAmB;IACnB,kBAAkB;IAClB,iBAAiB;IACjB,aAAa;IACb,aAAa;IACb,YAAY;IACZ,WAAW;EACb;EACA;IACE,SAAS;IACT,OAAO;IACP,aAAa;IACb,YAAY;IACZ,wBAAwB;IACxB,4BAA4B;IAC5B,kBAAkB;IAClB;QACI,WAAW;;OAEZ;EACL;EACA;IACE,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;IACf,mBAAmB;IACnB,gBAAgB;IAChB,WAAW;IACX;MACE,sBAAsB;MACtB,kBAAkB;EACtB;EACA","sourcesContent":[".footer {\n    background-image: url(https://www.zazmic.com/wp-content/themes/zazmic/img/bg.png);\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n  padding-top: 20px;\n  }\n  .footer__container {\n    flex-direction: row;\n    width: 1250px;\n    margin: 0 auto;\n    max-width: 100%;\n    height: 100%;\n    justify-content: space-between;\n    display: flex;\n    @media screen and (max-width: 600px) {\n      flex-wrap: wrap;\n      width: 100%;\n    }\n  }\n  .copyright {\n    flex-direction: row;\n    width: 1250px;\n    margin: 0 auto;\n    max-width: 100%;\n    height: 100%;\n    justify-content: space-between;\n    display: flex;\n    @media screen and (max-width: 600px) {\n      flex-direction: column-reverse;\n      align-items: center;\n    }\n  }\n  .footer-block {\n    display: flex;\n    flex-direction: column;\n  }\n  .footer-title {\n    color: #1e1c1a !important;\n    font-size: 17px;\n    font-weight: bold;\n    letter-spacing: 0;\n    line-height: 30px;\n    margin: 0;\n    text-align: left;\n    padding-bottom: 20px;\n  }\n  .footer-list {\n    margin: 0;\n    padding: 0;\n  }\n  .footer-item {\n    color: #1e1c1a !important;\n    font-size: 14px;\n    font-weight: bold;\n    letter-spacing: 0;\n    line-height: 30px;\n    margin: 0;\n    text-decoration: underline;\n    text-align: left;\n    margin-bottom: 10px;\n  }\n  .footer-address {\n    color: #1e1c1a !important;\n    font-size: 14px;\n    font-weight: bold;\n    letter-spacing: 0;\n    line-height: 30px;\n    margin: 0;\n    text-align: left;\n    margin-bottom: 10px;\n  }\n  .footer-btn {\n    height: 40px;\n    width: 145px;\n    border: none;\n    background-color: #1e1c1a;\n    color: #ffffff;\n    font-family: Roboto;\n    font-size: 14px;\n    font-weight: 500;\n    letter-spacing: 0;\n    line-height: 16px;\n    box-sizing: border-box;\n    cursor: pointer;\n  }\n  .footer__social {\n    align-items: center;\n    flex-direction: row;\n    margin-top: 65px;\n    display: flex;\n  \n    height: 100px;\n    width: 590px;\n    max-width: 100%;\n    padding: 20px 0 0 255px;\n    @media screen and (max-width: 900px) {\n      padding: 20px 0 0 0;\n      justify-content: center;\n    }\n  }\n  .content__social-media {\n    background-color: #000;\n    justify-content: center;\n    box-sizing: border-box;\n    align-items: center;\n    border-radius: 50%;\n    margin-right: 9px;\n    display: flex;\n    padding: 12px;\n    height: 36px;\n    width: 36px;\n  }\n  .footer__img {\n    bottom: 0;\n    left: 0;\n    height: 174px;\n    width: 590px;\n    background-size: contain;\n    background-repeat: no-repeat;\n    position: relative;\n    @media screen and (max-width: 600px) {\n        width: 100%;\n        \n       } \n  }\n  .copyright-copyright {\n    position: absolute;\n    margin-top: -69px;\n    font-size: 13px;\n    font-weight: normal;\n    line-height: 1.2;\n    color: #fff;\n    @media screen and (max-width: 600px) {\n      word-break: break-word;\n      margin-left: 114px;\n  }\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
